import { useTranslation } from "react-i18next";

import EditIcon from "@mui/icons-material/EditOutlined";
import { Box, Chip, FormHelperText, IconButton, Stack, TextField } from "@mui/material";

interface Props {
  label: string;
  value: string;
  isClientSpecific: boolean;
  onEdit?: () => void;
  editAriaLabel: string;
  errorMessage?: string;
}

export function LockedParticipantField({ label, value, isClientSpecific, onEdit, editAriaLabel, errorMessage }: Props) {
  const { t } = useTranslation();
  return (
    <Box>
      <TextField
        size="small"
        label={label}
        value={value}
        disabled
        fullWidth
        error={!!errorMessage}
        slotProps={{
          input: {
            readOnly: true,
            endAdornment: (
              <Stack direction="row" spacing={1} alignItems="center">
                {isClientSpecific && (
                  <Chip
                    label={t("proceedingParticipants.clientSpecificBadge")}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                )}
                {onEdit && (
                  <IconButton size="small" onClick={onEdit} aria-label={editAriaLabel}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </Stack>
            ),
          },
        }}
      />
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </Box>
  );
}
